/* eslint-env node */
exports.gatsbyRemarkAutolinkHeadersClassName =
  "gatsby-remark-autolink-headers-class-name";
